export const contact = {
  brandName: 'RITUALES Y ORIENTACIÓN ESPIRITUAL',
  whatsapp: '+1 548 440 9080',
  whatsappHref: 'https://wa.me/15484409080',
  phone: '+1 786 622 4195',
  phoneHref: 'tel:+17866224195',
  email: 'ritualesyhechizosdeamor7@gmail.com',
  emailHref: 'mailto:ritualesyhechizosdeamor7@gmail.com',
  address: '8707 NW 22nd Ave, Miami, FL 33147',
  addressHref: 'https://maps.google.com/?q=8707+NW+22nd+Ave,+Miami,+FL+33147',
  videoCallHref:
    'https://wa.me/15484409080?text=Quiero%20agendar%20una%20consulta%20por%20videollamada',
} as const
